import { z } from 'zod'

import { ChannelType } from 'common/core/constants/ChannelType'
import {
  ReasonTypes,
  ReasonRequestType,
} from 'common/oneTimeNotify/constants/notifyReasonConstants'
import { NotificationReasonSchema } from 'shared/api/common/schemas/notificationReason'

import { TitleErrorSchema } from './errors'

const notificationReasonCreateObjectSchema = z.object({
  caption: z.string(),
  channel: z.enum(ChannelType),
  context_flow_ns: z.string().optional(),
  request_title: z.string().nullable(),
  type: z.enum(ReasonTypes).nullable(),
  description: z.string().optional(),
})

export const NotificationReasonSchemas = {
  getList: {
    query: z.object({
      active_only: z.boolean(),
      channel: z.enum(ChannelType).optional(),
      notification_type: z.enum(ReasonRequestType).optional(),
    }),
    response: z.object({
      reasons: z.array(NotificationReasonSchema),
    }),
    path: z.undefined(),
  },
  create: {
    query: z.object({
      client_id: z.string(),
    }),
    request: notificationReasonCreateObjectSchema,
    response: z.object({
      reason: NotificationReasonSchema,
    }),
    path: z.undefined(),
    errors: {
      titleError: TitleErrorSchema,
    },
  },
  archive: {
    query: z.undefined(),
    request: z.object({
      reason_id: z.number(),
    }),
    response: z.undefined(),
    path: z.undefined(),
  },
  delete: {
    query: z.undefined(),
    request: z.object({
      reason_id: z.number(),
    }),
    response: z.undefined(),
    path: z.undefined(),
  },
  restore: {
    query: z.undefined(),
    request: z.object({
      reason_id: z.number(),
    }),
    response: z.undefined(),
    path: z.undefined(),
  },
}

export type NotificationReasonGetListPayload = z.infer<
  typeof NotificationReasonSchemas.getList.query
>
export type NotificationReasonCreateObject = z.infer<typeof notificationReasonCreateObjectSchema>
